import React from 'react'
import { navigate } from 'gatsby'
import {
  useSessionService,
  useUserService,
  hasDOM,
  ErrorBoundary,
} from '@rebeldotcom/ui'
import Layout from '../components/layout'
import { Order } from '../features/checkout'

const SLUG = '/checkout'

const CheckOutWrapper = ({}) => (
  <Layout hasCheckOutNav hasNavigation={false} location={SLUG}>
    <CheckOut />
  </Layout>
)

const CheckOut = ({}) => {
  const { setUseOldCart, doUseOldCart } = useSessionService()
  const { user, isLoading } = useUserService()
  let optOutCart = null
  if (hasDOM) {
    const params = new URLSearchParams(window.location.search)
    if (params !== null) {
      optOutCart = params.get('optOutCart')
    }

    if (user || !isLoading) {
      if (user && user.customerId) {
        if (user.status === 'On Hold') {
          navigate('/OnHold.aspx')
          return null
        }
      }
    }
  }

  if (optOutCart) {
    setUseOldCart(true)
  }

  if (doUseOldCart() && hasDOM) {
    window.location.href = '/MyAccount/ShoppingCart.aspx?optOutCart=true'
  }

  return (
    <ErrorBoundary location={SLUG}>
      <Order path="/" slug={SLUG} user={user} />
    </ErrorBoundary>
  )
}

export default CheckOutWrapper
